/* Oralua custom scripts — externalized for browser caching
 * Refactored from snippets/custom-code-body.liquid on 2026-05-11
 */

// 1. Color swatch painter + product media filter by alt text
(function () {
  'use strict';
  var COLOR_MAP = {
    'Black': '#000000', 'Cocoa': '#3d2817', 'Cocoa Brown': '#442B27',
    'Mud': '#7a5d44', 'Mud Brown': '#AF745B', 'Sand': '#d4b896',
    'White': '#ffffff', 'Red': '#8b1a1a', 'Cognac': '#8b5a2b',
    'Sagefield': '#5d6b4a', 'Shiraz': '#5c1a1b'
  };
  var COLOR_NAMES = Object.keys(COLOR_MAP).map(function(c) { return c.toLowerCase(); });

  function paintSwatches() {
    Object.keys(COLOR_MAP).forEach(function (colorName) {
      var hex = COLOR_MAP[colorName];
      var selectors = [
        '.m-product-option--node[data-value="' + colorName + '" i] .m-product-option--node__label',
        '.m-product-option--node__label[data-value="' + colorName + '" i]',
        '.m-product-card__swatch[data-value="' + colorName + '" i]',
        '.m-product-card__swatch[data-color="' + colorName + '" i]'
      ];
      selectors.forEach(function (sel) {
        try {
          document.querySelectorAll(sel).forEach(function (label) {
            var optionType = label.getAttribute('data-option-type');
            if (optionType && optionType !== 'color' && optionType !== 'default') return;
            label.style.setProperty('background-color', hex, 'important');
            label.style.setProperty('background', hex, 'important');
            if (colorName === 'White') label.style.setProperty('border-color', '#ddd', 'important');
          });
        } catch (e) {}
      });
    });
  }

  function getSelectedColor() {
    var checked = document.querySelector('input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="color"]:checked');
    if (checked && checked.value) return checked.value;
    var label = document.querySelector('.m-product-option--label .option-label--selected');
    if (label && label.textContent) return label.textContent.trim();
    return null;
  }

  function filterMedia(color) {
    if (!color) return;
    var c = color.toLowerCase().trim();
    var items = document.querySelectorAll('.m-product-media--item');
    if (items.length === 0) return;

    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) { item.style.display = ''; return; }
      var alt = (img.alt || '').toLowerCase();

      var mentioned = [];
      for (var i = 0; i < COLOR_NAMES.length; i++) {
        if (alt.indexOf(COLOR_NAMES[i]) !== -1) mentioned.push(COLOR_NAMES[i]);
      }

      if (mentioned.length === 0) {
        item.style.display = '';
        return;
      }

      if (mentioned.indexOf(c) === -1) {
        item.style.display = 'none';
        return;
      }

      var hasConflict = false;
      for (var j = 0; j < mentioned.length; j++) {
        var m = mentioned[j];
        if (m === c) continue;
        if (m.indexOf(c) !== -1 || c.indexOf(m) !== -1) continue;
        hasConflict = true;
        break;
      }
      item.style.display = hasConflict ? 'none' : '';
    });
  }

  function update() {
    paintSwatches();
    if (document.querySelector('form[action*="/cart/add"]')) {
      var color = getSelectedColor();
      if (color) filterMedia(color);
    }
  }

  function init() {
    update();
    setTimeout(update, 200); setTimeout(update, 600); setTimeout(update, 1500); setTimeout(update, 3000);
    document.addEventListener('change', function (e) {
      var name = (e.target && e.target.name || '').toLowerCase();
      if (name.indexOf('color') !== -1 || name.indexOf('options') !== -1) setTimeout(update, 80);
    });
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.m-product-option--node, [data-option-type="color"]');
      if (swatch) setTimeout(update, 150);
    });
    if (window.MutationObserver) {
      var debounce = null;
      var obs = new MutationObserver(function () {
        if (debounce) clearTimeout(debounce);
        debounce = setTimeout(update, 200);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// 2. Product card variant picker (color swatch click on cards)
(function () {
  'use strict';
  var productCache = {};
  function getCardHandle(card) {
    var picker = card.querySelector('[data-pcard-variant-picker]');
    return picker && picker.dataset.productHandle;
  }
  function getEmbeddedVariants(card) {
    var picker = card.querySelector('[data-pcard-variant-picker]');
    if (!picker) return null;
    var jsonScript = picker.querySelector('script[type="application/json"]');
    if (!jsonScript) return null;
    try { return JSON.parse(jsonScript.textContent); } catch (e) { return null; }
  }
  function fetchProductData(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { productCache[handle] = data; return data; })
      .catch(function () { return null; });
  }
  function applyVariantToCard(card, variant) {
    if (!card || !variant) return false;
    var newSrc = null;
    if (variant.featured_image && variant.featured_image.src) newSrc = variant.featured_image.src;
    else if (variant.featured_media) {
      if (variant.featured_media.src) newSrc = variant.featured_media.src;
      else if (variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        newSrc = variant.featured_media.preview_image.src;
      }
    }
    var ok = false;
    if (newSrc) {
      var fullSrc = newSrc;
      if (/[?&]width=/.test(fullSrc)) fullSrc = fullSrc.replace(/([?&]width=)\d+/, '$1600');
      else fullSrc = fullSrc + (fullSrc.indexOf('?') !== -1 ? '&' : '?') + 'width=600';
      var imgs = card.querySelectorAll('.m-product-card__media img, .m-product-card__main-image img, .m-product-card__hover-image img');
      imgs.forEach(function (img) { img.src = fullSrc; img.removeAttribute('srcset'); });
      var sources = card.querySelectorAll('.m-product-card__media picture source, .m-product-card__main-image picture source');
      sources.forEach(function (source) { source.setAttribute('srcset', fullSrc); });
      ok = true;
    }
    var input = card.querySelector('input[name="id"]');
    if (input) { input.value = String(variant.id); input.setAttribute('value', String(variant.id)); }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.pathname.indexOf('/products/') === -1) return;
        url.searchParams.set('variant', variant.id);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {}
    });
    return ok;
  }
  function updateSelectedSwatchUI(card, position, value) {
    card.querySelectorAll('.m-product-option--node__label[data-option-position="' + position + '"]').forEach(function (s) {
      if ((s.getAttribute('data-value') || '') === value) s.dataset.selected = 'true';
      else delete s.dataset.selected;
    });
  }
  function findVariant(variants, position, value) {
    if (!variants || !Array.isArray(variants)) return null;
    var optKey = 'option' + position;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i][optKey] === value) return variants[i];
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.m-product-card .m-product-option--node__label');
    if (!swatch) return;
    var card = swatch.closest('.m-product-card');
    if (!card) return;
    var optionValue = swatch.getAttribute('data-value');
    var optionPosition = parseInt(swatch.getAttribute('data-option-position') || '1', 10);
    if (!optionValue) return;
    updateSelectedSwatchUI(card, optionPosition, optionValue);
    var variants = getEmbeddedVariants(card);
    var matching = findVariant(variants, optionPosition, optionValue);
    if (matching && applyVariantToCard(card, matching)) return;
    var handle = getCardHandle(card);
    if (!handle) return;
    fetchProductData(handle).then(function (product) {
      if (!product || !product.variants) return;
      var match = findVariant(product.variants, optionPosition, optionValue);
      if (match) applyVariantToCard(card, match);
    });
  }, false);
})();

// 3. Card link updater (keep ?variant= in product card links)
(function () {
  'use strict';
  function updateCardLink(card) {
    if (!card) return;
    var variantInput = card.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) return;
    var variantId = variantInput.value;
    var anchors = card.querySelectorAll('a[href*="/products/"]');
    anchors.forEach(function (link) {
      try {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/products/') === -1) return;
        var url = new URL(href, window.location.origin);
        url.searchParams.set('variant', variantId);
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {}
    });
  }
  function updateAllCards() {
    document.querySelectorAll('.m-product-card').forEach(updateCardLink);
  }
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.m-product-card .m-product-option--node__label');
    if (!swatch) return;
    var card = swatch.closest('.m-product-card');
    if (!card) return;
    setTimeout(function () { updateCardLink(card); }, 60);
    setTimeout(function () { updateCardLink(card); }, 280);
    setTimeout(function () { updateCardLink(card); }, 800);
  }, true);
  function boot() {
    updateAllCards();
    setTimeout(updateAllCards, 600);
    setTimeout(updateAllCards, 1800);
    setTimeout(updateAllCards, 3500);
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
  if (window.MutationObserver) {
    var debounce;
    var obs = new MutationObserver(function (mutations) {
      var hasAdditions = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { hasAdditions = true; break; }
      }
      if (!hasAdditions) return;
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(updateAllCards, 350);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();

// 4. Judge.me widget refresh on accordion open
(function () {
  'use strict';
  function refreshJudgeMe() {
    try {
      if (window.jdgm && typeof window.jdgm.handler === 'function') window.jdgm.handler();
      if (typeof window.jdgmSetup === 'function') window.jdgmSetup();
      if (window.jdgm && window.jdgm.SETTINGS && typeof window.jdgm.runValidations === 'function') {
        window.jdgm.runValidations();
      }
      var rebuild = new Event('jdgm.event.RebuildBadges', { bubbles: true });
      document.dispatchEvent(rebuild);
      var loadEvts = new Event('jdgm-event-fire-load-events', { bubbles: true });
      document.dispatchEvent(loadEvts);
    } catch (e) {}
  }
  document.addEventListener('toggle', function (e) {
    if (!e.target || e.target.tagName !== 'DETAILS' || !e.target.open) return;
    var summary = e.target.querySelector('summary');
    if (!summary) return;
    var txt = (summary.textContent || '').toLowerCase();
    if (txt.indexOf('review') === -1) return;
    setTimeout(refreshJudgeMe, 50);
    setTimeout(refreshJudgeMe, 350);
    setTimeout(refreshJudgeMe, 1200);
  }, true);
  function bootRefresh() {
    setTimeout(refreshJudgeMe, 700);
    setTimeout(refreshJudgeMe, 2000);
  }
  if (document.readyState === 'complete') bootRefresh();
  else window.addEventListener('load', bootRefresh);
})();
